export const KYC = {
  PAN: 'pan number',
  GST: 'gst number',
  COMPANY: 'company name',
} as const;

export type FieldItem = {
  _id?: string;
  required?: boolean;
  visible?: boolean;
  isOnboarding?: boolean;
  fieldId?: RawField;
  field?: RawField;
};

export type RawField = {
  fieldName?: string;
  fieldLabel?: string;
  fieldType?: string;
  placeholder?: string;
  options?: unknown[];
  validation?: {
    minLength?: number;
    maxLength?: number;
    min?: number;
    max?: number;
    pattern?: string;
  };
  isOnboarding?: boolean;
};

export type NormalizedField = {
  fieldName: string;
  fieldLabel: string;
  fieldType: string;
  placeholder: string;
  options: unknown[];
  validation?: RawField['validation'];
  isOnboarding: boolean;
  isRequired: boolean;
  visible: boolean;
};

export type FormValues = Record<string, unknown>;

export type KycDetails = Record<string, string>;

export type OnboardingFieldsResponse = {
  data?: {
    selectedFields?: FieldItem[];
    kycStatus?: {
      panVerified?: boolean;
      gstVerified?: boolean;
    };
  };
};

export type PanVerifyResponse = {
  data?: { panDetails?: KycDetails | null };
  message?: string;
};

export type GstVerifyResponse = {
  data?: {
    gstDetails?: KycDetails | null;
    gst_details?: KycDetails | null;
  };
  message?: string;
};

export type OnboardingFieldRow = {
  item: FieldItem;
  field: NormalizedField;
  index: number;
};
